export enum DocumentPostStatusEnum {
    Draft = 0,
    Posted = 1,
    Deleted = 2,
}